import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import { modifierList as cardModifierList } from '../../components/3-molecules/card/props-list';
import CardSkeleton from '../../components/3-molecules/card/card-skeleton';
import SetOfCards from '../../components/4-organisms/set-of-cards/set-of-cards';

const LABEL_MODIFIERS = ['label-thin'];
const LABEL_TAG = 'span';

const LatestNewsSkeleton = ({ skeletonColor, setsOfCardsModifiers, cardModifiers, maxContents }) => {
  const cards = Array(maxContents).fill(0);
  return (
    <Fragment>
      <SetOfCards
        cards={cards}
        modifiers={setsOfCardsModifiers}
        render={(_, index) => (
          <CardSkeleton
            key={index}
            skeletonColor={skeletonColor}
            modifiers={cardModifiers}
            labelModifiers={LABEL_MODIFIERS}
            hasTime
            hasTitle
            labelTag={LABEL_TAG}
          />
        )}
      />
    </Fragment>
  );
};

LatestNewsSkeleton.propTypes = {
  skeletonColor: PropTypes.string.isRequired,
  setsOfCardsModifiers: PropTypes.array.isRequired,
  cardModifiers: PropTypes.arrayOf(PropTypes.oneOf(cardModifierList)),
  maxContents: PropTypes.number,
};

export default LatestNewsSkeleton;
